export default __webpack_public_path__ + "static/media/CS_138.53cb9374.png";